/** Figma 5074-14025 / 5076-7118 — full-page survey entry frame (1280×1024 ref). */
export const SURVEY_ENTRY_HEADER_BAND_HEIGHT_PX = 260
export const SURVEY_ENTRY_CARD_MAX_WIDTH_PX = 1010
export const SURVEY_ENTRY_CARD_PADDING_PX = 33
export const SURVEY_ENTRY_CARD_RADIUS_PX = 12
export const SURVEY_ENTRY_CARD_MIN_HEIGHT_PX = 709
export const SURVEY_ENTRY_CONTENT_MAX_WIDTH_PX = 910
export const SURVEY_ENTRY_START_BUTTON_WIDTH_PX = 436
/** Figma 5076:7110 — content column inset from top of frame */
export const SURVEY_ENTRY_PAGE_TOP_PADDING_PX = 72
/** Figma 5074-14074 — logo asset (matches auth split 5074-12353) */
export const SURVEY_ENTRY_LOGO_WIDTH_PX = 237
export const SURVEY_ENTRY_LOGO_HEIGHT_PX = 108
/** Figma 5074-14074 → 5074-14038 — gap between major card sections */
export const SURVEY_ENTRY_SECTION_GAP_PX = 48
/** Figma 5074-14049 → 5074-14071 — stats row to Start Survey */
export const SURVEY_ENTRY_STATS_TO_ACTIONS_GAP_PX = 48
/** Horizontal inset: (1280 − 1010) / 2 */
export const SURVEY_ENTRY_PAGE_SIDE_INSET_PX = 135

/** Figma 5076:7406 / 5074-13982 — survey complete card (640px, not entry 1010px). */
export const SURVEY_COMPLETE_CARD_MAX_WIDTH_PX = 640
export const SURVEY_COMPLETE_CARD_PADDING_PX = 48
/** Equal space: card top → celebration image, and action buttons → card bottom. */
export const SURVEY_COMPLETE_CARD_VERTICAL_INSET_PX = 48
export const SURVEY_COMPLETE_ILLUSTRATION_MAX_WIDTH_PX = 281
export const SURVEY_COMPLETE_ILLUSTRATION_HEIGHT_PX = 188
/** Content width inside 48px horizontal padding (640 − 96). */
export const SURVEY_COMPLETE_INNER_MAX_WIDTH_PX = 544
/** Figma 5074-14004 / 5074-14006 — paired action buttons. */
export const SURVEY_COMPLETE_BUTTON_WIDTH_PX = 265
